<template>
  <aside class="panel sessionsbar" id="sessionsBar" :class="{ collapsed: sessionsPanelCollapsed, 'topics-open': topicsViewOpen }">
    <!-- <div class="header">
      <div class="header-top">
        <div class="header-copy menu-page-copy conversations-head-copy">
          <h2 class="title menu-page-title">对话栏</h2>
          <div class="eyebrow menu-page-eyebrow">CONVERSATIONS</div>
        </div>
        <div class="header-actions">
          <button
            class="panel-toggle has-alert"
            id="sessionsToggleBtn"
            aria-label="添加"
            :aria-expanded="sessionAddMenuOpen"
            type="button"
            @click.stop="toggleSessionAddMenu"
          >
            <svg viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </button>
          <div class="session-add-menu" id="sessionAddMenu" :inert="!sessionAddMenuOpen || undefined" :class="{ open: sessionAddMenuOpen }">
            <button class="session-add-item" type="button" @click="handleSessionAdd('agent')">
              <span class="session-add-item-icon"><svg viewBox="0 0 24 24" fill="none"><path d="M12 4a4 4 0 100 8 4 4 0 000-8zM5 20a7 7 0 0114 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
              <span>创建Agent</span>
            </button>
            <button class="session-add-item" type="button" @click="handleSessionAdd('group')">
              <span class="session-add-item-icon"><svg viewBox="0 0 24 24" fill="none"><path d="M16 20v-1a4 4 0 00-4-4H6a4 4 0 00-4 4v1M9 11a4 4 0 100-8 4 4 0 000 8zm13 9v-1a4 4 0 00-3-3.87" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
              <span>发起群聊</span>
            </button>
            <button class="session-add-item" type="button" @click="handleSessionAdd('coworker')">
              <span class="session-add-item-icon"><svg viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
              <span>发起会话</span>
            </button>
          </div>
        </div>
      </div>
    </div> -->

    <label class="search">
      <svg viewBox="0 0 24 24" fill="none"><path d="M21 21l-4.35-4.35m1.6-5.15a6.75 6.75 0 11-13.5 0 6.75 6.75 0 0113.5 0z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg>
      <input id="sessionSearchInput" placeholder="搜索会话" :value="sessionSearchQuery" @input="onSearchInput" @focus="hideMenus">
    </label>

    <div class="session-filters" id="sessionFilters">
      <button
        v-for="filter in ['all', 'agent', 'group', 'coworker']"
        :key="filter"
        class="session-filter"
        :class="{ active: currentSessionFilter === filter }"
        @click="setFilter(filter)"
      >{{ filterLabel(filter) }}</button>
    </div>

    <div class="session-list" id="sessionList" ref="sessionList" @scroll.passive="onListScroll">
      <!-- 缺省状态：接口已返回且 conversations 为空 -->
      <div v-if="conversationsLoaded && sessionItems.length === 0" class="session-list-empty">
        <svg viewBox="0 0 48 48" fill="none" width="40" height="40">
          <path d="M24 4C12.95 4 4 12.95 4 24c0 3.5.91 6.79 2.5 9.64L4 44l10.36-2.5C17.21 43.09 20.5 44 24 44c11.05 0 20-8.95 20-20S35.05 4 24 4z" stroke="#c8d4e3" stroke-width="2.5" fill="none" stroke-linejoin="round"/>
          <path d="M16 22h16M16 28h10" stroke="#c8d4e3" stroke-width="2.5" stroke-linecap="round"/>
        </svg>
        <div class="session-list-empty-title">暂无会话</div>
        <div class="session-list-empty-sub">点击下方「新建聊天」开始</div>
      </div>
      <!-- virtual scroll top spacer -->
      <div v-if="useVirtualScroll" :style="{ height: virtualPadTop + 'px', flexShrink: 0 }"></div>
      <div
        v-for="item in visibleSessionItems"
        :key="item.key"
        class="session-item"
        :class="{
          active: currentSessionKey === item.key,
          'has-topics': item.hasTopics,
          pinned: item.pinned
        }"
        :id="item.key + 'Session'"
        :data-session-key="item.key"
        :data-session-type="item.type"
        :data-pinned="item.pinned"
        :data-has-topics="item.hasTopics"
        :data-topic-key="item.topicKey"
        @click="onSessionClick(item)"
        @contextmenu.prevent="onSessionContextMenu($event, item)"
      >
        <div class="session-avatar-wrap">
          <SessionAvatar :session="item" />
          <span v-if="railAgentStatus(item)" class="session-avatar-status" :class="railAgentStatus(item)"></span>
        </div>
        <div class="session-main">
          <div class="session-topline">
            <div class="session-name-wrap">
              <div class="session-name">{{ item.name }}</div>
              <span v-if="item.isSystem || item.isService" class="tiny-tag system-tag">官方</span>
              <span v-if="item.type === 'agent'" class="tiny-tag agent-tag" :class="agentTagClass(item)" :title="agentTagTitle(item)">{{ agentTagText(item) }}</span>
              <span v-if="item.type === 'group'" class="tiny-tag group-tag">群组</span>
              <span v-if="(item.type === 'group' || item.type === 'coworker') && item.hasAgent" class="tiny-tag agent-tag" :class="agentTagClass(item)" :title="agentTagTitle(item)">{{ agentTagText(item) }}</span>
            </div>
          </div>
          <template v-if="item.hasTopics && getTopicSummary(item)">
            <div class="session-topic-summary">
              <div class="session-topic-tabs" :id="item.key + 'TopicTabs'">
                <span
                  v-for="topic in getTopics(item)"
                  :key="topic.key"
                  class="session-topic-tab"
                  :class="{ active: topic === getTopics(item)[0] }"
                >
                  <span class="session-topic-tab-label"><span>{{ topic.label }}</span></span>
                </span>
              </div>
              <div class="session-topic-message" :id="item.key + 'TopicMessage'">
                <template v-if="topicMessageDraft(item)"><span class="session-preview-draft">草稿:</span> {{ stripPreview(topicMessageDraft(item)) }}</template>
                <template v-else>{{ getTopicMessage(item) }}</template>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="session-preview">
              <template v-if="sessionDraft(item)"><span class="session-preview-draft">草稿:</span> {{ stripPreview(sessionDraft(item)) }}</template>
              <template v-else>{{ getSessionPreview(item) }}</template>
            </div>
          </template>
          <div class="session-meta">
            <!-- Agent 会话: 直接显示 Agent 自身状态(只有一个 agent) -->
            <template v-if="item.type === 'agent'">
              <span class="session-agent-status" :class="agentTagClass(item)" :title="agentTagTitle(item)">{{ agentTagText(item) }}</span>
            </template>
            <!-- 群组: 聚合"我自己"在群里所有 agent 的状态(任一忙→忙, 任一活→活, 全停→停) -->
            <template v-else-if="item.type === 'group' || item.type === 'coworker'">
              <span v-if="aggregateMyAgentStatus(item)" class="session-agent-status" :class="agentTagClass(item)" :title="agentTagTitle(item)">{{ agentTagText(item) }}</span>
            </template>
            <span v-if="item.metaTime" class="meta-time">{{ item.metaTime }}</span>
          </div>
        </div>
        <div class="session-datecol">
          <div class="session-date">{{ relativeTime(item.lastMessageAt) }}</div>
          <span v-if="item.mentionCount" class="session-mention-badge">@</span>
          <span v-if="item.unread" class="session-unread-badge">{{ item.unread }}</span>
        </div>
      </div>
      <!-- virtual scroll bottom spacer -->
      <div v-if="useVirtualScroll" :style="{ height: virtualPadBottom + 'px', flexShrink: 0 }"></div>
    </div>

    <!-- Topics view -->
    <section class="session-topics-view" id="sessionTopicsView" :aria-hidden="!topicsViewOpen" :class="{ open: topicsViewOpen }">
      <div class="session-topics-shell">
        <aside class="session-topic-rail">
          <button class="topic-rail-search" type="button" aria-label="搜索会话" @click="goToSearch">
            <svg viewBox="0 0 24 24" fill="none"><path d="M21 21l-4.35-4.35m1.6-5.15a6.75 6.75 0 11-13.5 0 6.75 6.75 0 0113.5 0z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </button>
          <div class="topic-rail-list" id="topicRailList">
            <button
              v-for="item in nonExitedSessions"
              :key="item.key"
              class="topic-rail-avatar"
              :class="{ active: currentSessionKey === item.key }"
              type="button"
              :data-rail-session="item.key"
              :aria-label="item.name"
              @click="onRailAvatarClick(item)"
            >
              <SessionAvatar :session="item" tag="span" />
              <span v-if="railAgentStatus(item)" class="topic-rail-dot" :class="railAgentStatus(item)"></span>
              <span v-if="item.unread" class="topic-rail-unread">{{ item.unread > 99 ? '99+' : item.unread }}</span>
            </button>
          </div>
        </aside>

        <div class="session-topics-pane">
          <div class="session-topics-head">
            <button class="topics-back-btn" id="topicsBackBtn" aria-label="返回会话列表" @click="setTopicsView({ open: false })">
              <svg viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            </button>
            <div class="session-topics-copy">
              <div class="session-topics-title" id="sessionTopicsTitle">{{ currentTopicsPage ? currentTopicsPage.title : '' }}</div>
              <div class="session-topics-sub" id="sessionTopicsSub">{{ currentTopicsPage ? currentTopicsPage.sub : '' }}</div>
            </div>
          </div>
          <div class="session-topics-list" id="sessionTopicsList">
            <template v-if="currentTopicsPage">
              <button
                v-for="topic in currentTopicsPage.topics"
                :key="topic.key"
                class="session-topic-item"
                :class="{ active: currentTopicKey === topic.key }"
                type="button"
                @click="onTopicItemClick(topic)"
                @contextmenu.prevent="openTopicContextMenu($event, topic)"
              >
                <span class="session-topic-icon" :style="{ background: topic.color }">{{ topic.icon }}</span>
                <span class="session-topic-main">
                  <span class="session-topic-head">
                    <span class="session-topic-name-wrap">
                      <span class="session-topic-name">{{ topic.name || topic.label }}</span>
                      <span v-if="topic.topicTag" class="tiny-tag agent-tag session-topic-agent-tag">{{ topic.topicTag }}</span>
                    </span>
                    <span class="session-topic-time">{{ topic.time }}</span>
                  </span>
                  <span class="session-topic-preview">
                    <span v-if="topic.author" class="session-topic-author">{{ topic.author }}</span>
                    <span class="session-topic-preview-text">
                      <template v-if="topicListDraft(topic)"><span class="session-preview-draft">草稿:</span> {{ stripPreview(topicListDraft(topic)) }}</template>
                      <template v-else>{{ stripPreview(topic.preview) }}</template>
                    </span>
                  </span>
                </span>
                <span class="session-topic-badges">
                  <span v-if="topic.mentionCount" class="session-mention-badge">@</span>
                  <span v-if="topic.unread" class="session-topic-unread">{{ topic.unread }}</span>
                </span>
              </button>
            </template>
          </div>
        </div>
      </div>
    </section>

    <!-- 新建聊天 固定底部按钮 + 专属弹窗 -->
    <div class="sessions-new-chat-bar">
      <div class="sessions-new-chat-popup" v-if="newChatMenuOpen" @click.stop>
        <button class="sessions-new-chat-item" type="button" @click="newChatAction('agent')">
          <span class="sessions-new-chat-item-icon">
            <svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M12 4a4 4 0 100 8 4 4 0 000-8zM5 20a7 7 0 0114 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </span>
          创建Agent
        </button>
        <button class="sessions-new-chat-item" type="button" @click="newChatAction('group')">
          <span class="sessions-new-chat-item-icon">
            <svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M16 20v-1a4 4 0 00-4-4H6a4 4 0 00-4 4v1M9 11a4 4 0 100-8 4 4 0 000 8zm13 9v-1a4 4 0 00-3-3.87" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </span>
          发起群聊
        </button>
        <button class="sessions-new-chat-item" type="button" @click="newChatAction('coworker')">
          <span class="sessions-new-chat-item-icon">
            <svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M8 12h8M12 8v8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
          </span>
          发起会话
        </button>
      </div>
      <button class="sessions-new-chat-btn" type="button" @click.stop="toggleNewChatMenu">
        <svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>
        新建聊天
      </button>
    </div>
    <!-- 停用确认弹窗（teleport 到 body）— 2026-05-28 起 DELETE /agents/:id 改为停用语义: 数据保留, 仅对外不可用 -->
    <div v-show="fireConfirm.open" class="ss-confirm-overlay" ref="fireOverlay" @click.self="cancelFire">
      <div class="ss-confirm-dialog">
        <div class="ss-confirm-title">确认停用「{{ (fireConfirm.item && fireConfirm.item.name) || 'Agent' }}」？</div>
        <div class="ss-confirm-desc">停用后该 Agent 将无法再接收新任务，仅可查看交付物与详情。</div>
        <div class="ss-confirm-actions">
          <button class="ss-confirm-btn" type="button" @click="cancelFire" :disabled="fireConfirm.loading">取消</button>
          <button class="ss-confirm-btn danger" type="button" @click="confirmFire" :disabled="fireConfirm.loading">{{ fireConfirm.loading ? '处理中…' : '确认停用' }}</button>
        </div>
      </div>
    </div>

    <!-- 话题右键菜单（agent 私聊）— teleport 到 body 避免 transform 干扰 -->
    <div v-show="topicCtx.open" class="topic-context-menu" ref="topicCtxMenu" :style="{ left: topicCtx.x + 'px', top: topicCtx.y + 'px' }">
      <button class="topic-context-item" type="button" @click.stop="openRenameTopic">重命名</button>
      <button v-if="topicCtx.sessionType === 'agent'" class="topic-context-item danger" type="button" @click.stop="confirmCloseTopic">关闭任务</button>
      <template v-if="topicCtx.sessionType === 'group'">
        <button class="topic-context-item danger" type="button" @click.stop="confirmCloseTopic">关闭话题</button>
        <button class="topic-context-item danger" type="button" @click.stop="exitGroupFromTopicCtx">退出群聊</button>
      </template>
    </div>

    <!-- 会话列表右键菜单 — 跟随鼠标，teleport 到 body 避免 transform 干扰 -->
    <div v-show="sessionContextMenu.open && sessionCtxItem" class="session-inline-menu" ref="sessionCtxMenu" :style="contextMenuStyle" @click.stop>
      <button class="session-context-item" type="button" @click.stop="togglePin">
        {{ isPinned ? '取消置顶' : '置顶会话' }}
      </button>
      <button
        v-if="sessionCtxItem && sessionCtxItem.type === 'agent' && sessionCtxItem.myAgentStatus !== 'disabled'"
        class="session-context-item warn"
        type="button"
        @click.stop="fireAgent(sessionCtxItem)"
      >停用 Agent</button>
    </div>

    <!-- 关闭任务确认弹窗 — teleport 到 body -->
    <div v-show="topicCloseConfirm.open" class="topic-close-mask" ref="topicCloseMask" @click.self="cancelCloseTopic">
      <div class="topic-close-dialog">
        <div class="topic-close-title">关闭{{ closeTopicNoun }}</div>
        <div class="topic-close-body">关闭后此{{ closeTopicNoun }}将被删除，且无法恢复。是否继续？</div>
        <div class="topic-close-actions">
          <button class="topic-close-btn" type="button" :disabled="topicCloseConfirm.loading" @click="cancelCloseTopic">取消</button>
          <button class="topic-close-btn danger" type="button" :disabled="topicCloseConfirm.loading" @click="doCloseTopic">{{ topicCloseConfirm.loading ? '关闭中…' : '确认关闭' }}</button>
        </div>
        <div v-if="topicCloseConfirm.error" class="topic-close-error">{{ topicCloseConfirm.error }}</div>
      </div>
    </div>

    <!-- 修改话题名称弹窗 — teleport 到 body -->
    <div v-show="topicRename.open" class="topic-close-mask" ref="topicRenameMask" @click.self="cancelRenameTopic">
      <div class="topic-close-dialog">
        <div class="topic-close-title">修改话题名称</div>
        <input
          ref="topicRenameInput"
          v-model="topicRename.name"
          class="topic-rename-input"
          type="text"
          maxlength="128"
          placeholder="输入话题名称"
          @keydown.enter="doRenameTopic"
          @keydown.esc="cancelRenameTopic"
        />
        <div class="topic-close-actions">
          <button class="topic-close-btn" type="button" :disabled="topicRename.loading" @click="cancelRenameTopic">取消</button>
          <button class="topic-close-btn primary" type="button" :disabled="topicRename.loading || !topicRename.name.trim()" @click="doRenameTopic">{{ topicRename.loading ? '保存中…' : '保存' }}</button>
        </div>
        <div v-if="topicRename.error" class="topic-close-error">{{ topicRename.error }}</div>
      </div>
    </div>
  </aside>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { api } from '@/utils/api'
import { stripMarkdown } from '@/utils/markdown'
import SessionAvatar from './SessionAvatar.vue'

export default {
  name: 'SessionsBar',
  components: { SessionAvatar },
  data() {
    return {
      activeTopicKeys: {},
      vsScrollTop: 0,
      vsContainerH: 600,
      VS_THRESHOLD: 35,
      VS_ITEM_H: 82,
      VS_BUFFER: 5,
      _timeTick: 0,
      newChatMenuOpen: false,
      // 停用确认弹窗 (2026-05-28 起 DELETE /agents/:id 改为停用语义)
      fireConfirm: { open: false, item: null, loading: false },
      topicCtx: { open: false, x: 0, y: 0, topic: null, sessionKey: '', sessionType: '' },
      topicCloseConfirm: { open: false, topic: null, sessionKey: '', sessionType: '', loading: false, error: '' },
      topicRename: { open: false, topic: null, sessionKey: '', name: '', loading: false, error: '' }
    }
  },
  computed: {
    ...mapState([
      'currentSessionKey',
      'currentSessionType',
      'currentSessionFilter',
      'sessionSearchQuery',
      'sessionsPanelCollapsed',
      'topicsViewOpen',
      'currentTopicsPageKey',
      'currentTopicKey',
      'sessionContextMenu',
      'sessionAddMenuOpen',
      'sessionTopicPages',
      'sessionItems',
      'conversationsLoaded',
      'conversations',
      'composerInputValues',
      'conversationAgents',
      'currentUserId'
    ]),
    ...mapGetters(['filteredSessionItems', 'currentTopicsPage']),
    // 关闭确认弹窗用词：agent 叫"任务"，群聊叫"话题"
    closeTopicNoun() {
      return this.topicCloseConfirm.sessionType === 'agent' ? '任务' : '话题'
    },
    nonExitedSessions() {
      return this.filteredSessionItems
    },
    useVirtualScroll() {
      return this.filteredSessionItems.length > this.VS_THRESHOLD
    },
    visibleSessionItems() {
      if (!this.useVirtualScroll) return this.filteredSessionItems
      const h = this.VS_ITEM_H
      const start = Math.max(0, Math.floor(this.vsScrollTop / h) - this.VS_BUFFER)
      const count = Math.ceil(this.vsContainerH / h) + this.VS_BUFFER * 2
      return this.filteredSessionItems.slice(start, start + count)
    },
    virtualPadTop() {
      if (!this.useVirtualScroll) return 0
      const h = this.VS_ITEM_H
      const start = Math.max(0, Math.floor(this.vsScrollTop / h) - this.VS_BUFFER)
      return start * h
    },
    virtualPadBottom() {
      if (!this.useVirtualScroll) return 0
      const h = this.VS_ITEM_H
      const total = this.filteredSessionItems.length
      const start = Math.max(0, Math.floor(this.vsScrollTop / h) - this.VS_BUFFER)
      const count = Math.ceil(this.vsContainerH / h) + this.VS_BUFFER * 2
      const end = Math.min(total, start + count)
      return (total - end) * h
    },
    contextMenuStyle() {
      if (!this.sessionContextMenu.open) return {}
      return { left: this.sessionContextMenu.x + 'px', top: this.sessionContextMenu.y + 'px' }
    },
    isPinned() {
      if (!this.sessionContextMenu.sessionKey) return false
      const item = this.sessionItems.find(s => s.key === this.sessionContextMenu.sessionKey)
      return item ? item.pinned : false
    },
    sessionCtxItem() {
      if (!this.sessionContextMenu.sessionKey) return null
      return this.sessionItems.find(s => s.key === this.sessionContextMenu.sessionKey) || null
    }
  },
  methods: {
    relativeTime(ts) {
      void this._timeTick // 触发响应式依赖
      if (!ts) return ''
      const now = Date.now()
      const t = typeof ts === 'number' ? ts : new Date(ts).getTime()
      const diff = now - t
      if (diff < 60000) return '刚刚'
      if (diff < 3600000) return Math.floor(diff / 60000) + '分钟前'
      const d = new Date(t)
      const today = new Date()
      if (d.toDateString() === today.toDateString()) {
        return d.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit', hour12: false })
      }
      const yesterday = new Date(today - 86400000)
      if (d.toDateString() === yesterday.toDateString()) return '昨天'
      return d.toLocaleDateString('zh-CN', { month: 'numeric', day: 'numeric' })
    },
    onListScroll(e) {
      this.vsScrollTop = e.target.scrollTop
      this.vsContainerH = e.target.clientHeight
    },
    ...mapMutations([
      'SET_SESSION_FILTER',
      'SET_SESSION_SEARCH',
      'SET_SESSION_CONTEXT_MENU',
      'SET_SESSION_ADD_MENU_OPEN',
      'TOGGLE_SESSION_PIN',
      'SET_TOPIC_PAGE_ACTIVE_KEY'
    ]),
    ...mapActions(['setActiveSession', 'setTopicsView', 'openCreateGroupDialog', 'switchTopic']),
    filterLabel(filter) {
      const map = { all: '全部', agent: 'Agent', group: '群组', coworker: '同事' }
      return map[filter] || filter
    },
    statusLabel(status) {
      const map = { busy: '忙碌中', idle: '空闲中', offline: '离线' }
      return map[status] || status
    },
    // 归一 item.myAgentStatus 成 idle/busy/disabled 三档(myAgentStatus 由 WS 干活事件实时更新)
    //   1对1 agent: 总返回状态(无则 idle)
    //   群聊: 必须 hasMyAgent && myAgentStatus 都有才返回(否则 null = 不显示)
    //   不读 conversationAgents[].status —— 那个只在加载时拿一次, WS 干活不更新它, 会导致不同步
    aggregateMyAgentStatus(item) {
      if (!item) return null
      if (item.type !== 'agent' && !(item.hasMyAgent && item.myAgentStatus)) return null
      const s = item.myAgentStatus
      // 'busy' = 后端聚合的粗粒度字面值; 其余是 per-agent 原始态(1对1 流式路径写入)
      if (s === 'disabled' || s === 'shutdown') return 'disabled'
      if (s === 'busy' || s === 'thinking' || s === 'executing_tool' || s === 'initializing' || s === 'error' || s === 'init_failed') return 'busy'
      return 'idle'
    },
    agentTagClass(item) {
      const s = this.aggregateMyAgentStatus(item)
      if (s === 'disabled') return 'agent-disabled'
      if (s === 'busy') return 'agent-busy'
      return 'agent-idle'
    },
    agentTagText(item) {
      const s = this.aggregateMyAgentStatus(item)
      if (s === 'disabled') return '已停用'
      if (s === 'busy') return '忙碌中'
      return 'Agent'
    },
    agentTagTitle(item) {
      const s = this.aggregateMyAgentStatus(item)
      if (s === 'disabled') return '已停用：Agent 不再应答消息'
      if (s === 'busy') return '忙碌中'
      return '空闲中'
    },
    railAgentStatus(item) {
      // aggregateMyAgentStatus 内部已处理 1对1/群聊的 gating
      return this.aggregateMyAgentStatus(item)
    },
    agentStatusLabel(status) {
      const map = {
        initializing: '初始化中',
        init_failed: '初始化失败',
        offline: '离线',
        idle: '空闲',
        thinking: '思考中',
        executing_tool: '执行中',
        error: '运行错误',
        shutdown: '已休眠',
        disabled: '已停用'
      }
      return map[status] || status
    },
    onSearchInput(e) {
      const val = e.target.value
      if (this._searchTimer) clearTimeout(this._searchTimer)
      this._searchTimer = setTimeout(() => {
        this.SET_SESSION_SEARCH(val)
      }, 200)
    },
    setFilter(filter) {
      this.SET_SESSION_FILTER(filter)
      this.hideMenus()
    },
    hideMenus() {
      this.SET_SESSION_CONTEXT_MENU({ open: false })
      this.SET_SESSION_ADD_MENU_OPEN(false)
    },
    toggleNewChatMenu() {
      this.newChatMenuOpen = !this.newChatMenuOpen
    },
    newChatAction(type) {
      this.newChatMenuOpen = false
      this.handleSessionAdd(type)
    },
    toggleSessionAddMenu() {
      this.SET_SESSION_ADD_MENU_OPEN(!this.sessionAddMenuOpen)
    },
    handleSessionAdd(type) {
      this.SET_SESSION_ADD_MENU_OPEN(false)
      if (type === 'agent') {
        this.$router.push({ name: 'experts' })
      } else if (type === 'group') {
        this.$store.commit('SET_GROUP_DIALOG', { open: true, mode: 'create-group', sessionKey: '' })
      } else if (type === 'coworker') {
        this.$store.commit('SET_GROUP_DIALOG', { open: true, mode: 'create-direct', sessionKey: '' })
      }
    },
    goToSearch() {
      this.setTopicsView({ open: false })
      this.$nextTick(() => {
        const el = document.getElementById('sessionSearchInput')
        if (el) el.focus()
      })
    },
    onSessionClick(item) {
      // 如果右键菜单打开中，点击只关闭菜单，不切换会话
      if (this.sessionContextMenu.open) {
        this.SET_SESSION_CONTEXT_MENU({ open: false })
        return
      }
      this.hideMenus()
      this.setActiveSession(item.key)
      if (item.hasTopics && item.topicKey) {
        this.setTopicsView({ open: true, pageKey: item.topicKey })
      } else if (this.topicsViewOpen) {
        this.setTopicsView({ open: false })
      }
    },
    onSessionContextMenu(event, item) {
      event.preventDefault()
      this.SET_SESSION_ADD_MENU_OPEN(false)
      // 切换：再次右击同一条目则关闭
      if (this.sessionContextMenu.open && this.sessionContextMenu.sessionKey === item.key) {
        this.SET_SESSION_CONTEXT_MENU({ open: false })
      } else {
        this.SET_SESSION_CONTEXT_MENU({ open: true, sessionKey: item.key, x: event.clientX, y: event.clientY })
      }
    },
    async togglePin() {
      const key = this.sessionContextMenu.sessionKey
      this.SET_SESSION_CONTEXT_MENU({ open: false })
      if (!key) return
      const item = this.$store.state.sessionItems.find(s => s.key === key)
      if (!item) return
      const newPinned = !item.pinned
      const convId = item.conversationId
      if (convId) {
        try {
          await api.updateConversation(convId, { pinned: newPinned })
        } catch (e) {
          console.warn('[SessionsBar] togglePin failed:', e.message)
          return
        }
      }
      this.TOGGLE_SESSION_PIN(key)
    },
    fireAgent(item) {
      this.SET_SESSION_CONTEXT_MENU({ open: false })
      if (!item || item.type !== 'agent') return
      this.fireConfirm = { open: true, item, loading: false }
    },
    cancelFire() {
      this.fireConfirm = { open: false, item: null, loading: false }
    },
    async confirmFire() {
      const item = this.fireConfirm.item
      if (!item) return
      this.fireConfirm.loading = true
      try {
        let agentId = item.agentId
        if (!agentId) {
          const cached = this.$store.state.conversationAgents[item.conversationId] || []
          agentId = cached.length ? cached[0].id : null
        }
        if (!agentId && item.conversationId) {
          // 兜底：拉接口获取
          await this.$store.dispatch('fetchConversationAgents', item.conversationId)
          const fresh = this.$store.state.conversationAgents[item.conversationId] || []
          agentId = fresh.length ? fresh[0].id : null
        }
        if (!agentId) throw new Error('找不到对应 Agent')
        await api.deleteAgent(agentId)
        await this.$store.dispatch('fetchConversations', { force: true })
        this.fireConfirm = { open: false, item: null, loading: false }
      } catch (e) {
        console.warn('[SessionsBar] fireAgent failed:', e && e.message)
        this.fireConfirm.loading = false
      }
    },
    getTopicSummary(item) {
      return this.sessionTopicPages[item.topicKey] || null
    },
    getTopics(item) {
      const page = this.sessionTopicPages[item.topicKey]
      return page ? page.topics : []
    },
    getActiveTopicKey(item) {
      if (this.activeTopicKeys[item.topicKey]) return this.activeTopicKeys[item.topicKey]
      const page = this.sessionTopicPages[item.topicKey]
      return page ? page.activeKey : null
    },
    getTopicMessage(item) {
      const page = this.sessionTopicPages[item.topicKey]
      if (!page || !page.topics || !page.topics.length) return ''
      const active = page.topics.find(t => t.key === page.activeKey) || page.topics[0]
      return stripMarkdown(active.message || '')
    },
    getSessionPreview(item) {
      if (item.lastMessage) return stripMarkdown(item.lastMessage)
      return '暂无最新消息'
    },
    stripPreview(text) {
      return stripMarkdown(text || '')
    },
    sessionDraft(item) {
      // 当前选中会话不在列表里显示草稿（草稿就在输入框里）
      if (item.key === this.currentSessionKey) return ''
      const map = this.composerInputValues || {}
      const prefix = item.key + '-'
      for (const k in map) {
        if (k.indexOf(prefix) === 0) {
          const v = (map[k] || '').trim()
          if (v) return v
        }
      }
      return ''
    },
    topicMessageDraft(item) {
      if (item.key === this.currentSessionKey) return ''
      const map = this.composerInputValues || {}
      const page = this.sessionTopicPages[item.topicKey]
      const activeKey = page ? page.activeKey : null
      if (!activeKey) return ''
      const prefix = item.key + '-'
      const suffix = '-' + activeKey
      for (const k in map) {
        if (k.indexOf(prefix) === 0 && k.indexOf(suffix, k.length - suffix.length) >= 0) {
          const v = (map[k] || '').trim()
          if (v) return v
        }
      }
      return ''
    },
    topicListDraft(topic) {
      if (!this.currentTopicsPage) return ''
      const sk = this.currentTopicsPage.sessionKey
      if (!sk || !topic || !topic.key) return ''
      // 当前激活 topic 在输入框里有草稿，不在话题列表里再显示一遍
      if (sk === this.currentSessionKey && this.currentTopicKey === topic.key) return ''
      const map = this.composerInputValues || {}
      const prefix = sk + '-'
      const suffix = '-' + topic.key
      for (const k in map) {
        if (k.indexOf(prefix) === 0 && k.indexOf(suffix, k.length - suffix.length) >= 0) {
          const v = (map[k] || '').trim()
          if (v) return v
        }
      }
      return ''
    },
    onTopicTabClick(item, topic) {
      this.$set(this.activeTopicKeys, item.topicKey, topic.key)
      if (this.currentSessionKey === item.key) {
        this.switchTopic({ topicKey: topic.key, pageKey: item.topicKey })
      } else {
        this.setActiveSession({ sessionKey: item.key, targetTopicId: topic.key })
        this.switchTopic({ topicKey: topic.key, pageKey: item.topicKey })
      }
    },
    onTopicTabPreview(item, topic) {
      this.$set(this.activeTopicKeys, item.topicKey, topic.key)
    },
    onTopicItemClick(topic) {
      if (this.currentTopicsPageKey) {
        this.switchTopic({ topicKey: topic.key, pageKey: this.currentTopicsPageKey })
      }
    },
    openTopicContextMenu(e, topic) {
      if (!topic) return
      // 默认话题不参与改名/关闭 → 不弹菜单（菜单项会全空）
      if (topic.isDefault || topic.default) return
      const sessionKey = (this.currentTopicsPage && this.currentTopicsPage.sessionKey) || ''
      if (!sessionKey) return
      // agent 私聊 + 群聊都弹（群聊只给"修改名称"，关闭任务仍仅 agent）
      const session = this.$store.state.sessionItems.find(s => s.key === sessionKey)
      if (!session || (session.type !== 'agent' && session.type !== 'group')) return
      this.topicCtx = { open: true, x: e.clientX, y: e.clientY, topic, sessionKey, sessionType: session.type }
      setTimeout(() => document.addEventListener('click', this._closeTopicCtxOnce, { once: true }), 0)
    },
    _closeTopicCtxOnce() { this.topicCtx.open = false },
    confirmCloseTopic() {
      const { topic, sessionKey, sessionType } = this.topicCtx
      this.topicCtx.open = false
      if (!topic) return
      this.topicCloseConfirm = { open: true, topic, sessionKey, sessionType, loading: false, error: '' }
    },
    exitGroupFromTopicCtx() {
      const { sessionKey } = this.topicCtx
      this.topicCtx.open = false
      if (!sessionKey) return
      // 复用全局 GroupDialog 的退出群聊流程（mode='exit'，内部 dispatch exitGroupSession）
      this.$store.commit('SET_GROUP_DIALOG', { open: true, mode: 'exit', sessionKey })
    },
    cancelCloseTopic() {
      if (this.topicCloseConfirm.loading) return
      this.topicCloseConfirm = { open: false, topic: null, sessionKey: '', sessionType: '', loading: false, error: '' }
    },
    async doCloseTopic() {
      const { topic, sessionKey } = this.topicCloseConfirm
      if (!topic) return
      const session = this.$store.state.sessionItems.find(s => s.key === sessionKey)
      if (!session || !session.conversationId) {
        this.topicCloseConfirm.error = '会话状态异常'
        return
      }
      this.topicCloseConfirm.loading = true
      this.topicCloseConfirm.error = ''
      try {
        await api.deleteTopic(session.conversationId, topic.key)
        await this.$store.dispatch('fetchConversations', { force: true })
        // 切到剩余第一个话题
        const page = this.$store.state.sessionTopicPages[session.topicKey]
        if (page && page.topics && page.topics.length) {
          const next = page.topics.find(t => t.key !== topic.key) || page.topics[0]
          if (next) this.$store.dispatch('switchTopic', { topicKey: next.key, pageKey: session.topicKey })
        }
        this.topicCloseConfirm = { open: false, topic: null, sessionKey: '', sessionType: '', loading: false, error: '' }
      } catch (e) {
        this.topicCloseConfirm.error = (e && e.message) || '关闭失败'
        this.topicCloseConfirm.loading = false
      }
    },
    openRenameTopic() {
      const { topic, sessionKey } = this.topicCtx
      this.topicCtx.open = false
      if (!topic) return
      this.topicRename = { open: true, topic, sessionKey, name: topic.name || topic.label || '', loading: false, error: '' }
      this.$nextTick(() => { const el = this.$refs.topicRenameInput; if (el) { el.focus(); el.select() } })
    },
    cancelRenameTopic() {
      if (this.topicRename.loading) return
      this.topicRename = { open: false, topic: null, sessionKey: '', name: '', loading: false, error: '' }
    },
    async doRenameTopic() {
      const { topic, sessionKey, name } = this.topicRename
      const trimmed = (name || '').trim()
      if (!topic || !trimmed || this.topicRename.loading) return
      const session = this.$store.state.sessionItems.find(s => s.key === sessionKey)
      if (!session || !session.conversationId) { this.topicRename.error = '会话状态异常'; return }
      // 名字没变直接关
      if (trimmed === (topic.name || topic.label || '')) { this.cancelRenameTopic(); return }
      this.topicRename.loading = true
      this.topicRename.error = ''
      try {
        // PUT /conversations/:id/topics/:topicId { name }；成功后服务端 WS 推 topic.updated，列表自动刷新标题
        await api.updateTopic(session.conversationId, topic.key, { name: trimmed })
        this.topicRename = { open: false, topic: null, sessionKey: '', name: '', loading: false, error: '' }
      } catch (e) {
        this.topicRename.error = (e && e.message) || '修改失败'
        this.topicRename.loading = false
      }
    },
    onRailAvatarClick(item) {
      this.setActiveSession(item.key)
      if (item.hasTopics && item.topicKey) {
        this.setTopicsView({ open: true, pageKey: item.topicKey })
      } else {
        this.setTopicsView({ open: false })
      }
    },
    handleGlobalClick(event) {
      if (!this.$el.contains(event.target)) {
        this.SET_SESSION_CONTEXT_MENU({ open: false })
        this.SET_SESSION_ADD_MENU_OPEN(false)
        this.newChatMenuOpen = false
      }
    }
  },
  async created() {
    // 并行获取当前用户信息和会话列表
    await Promise.all([
      this.$store.dispatch('fetchCurrentUser'),
      this.$store.dispatch('fetchConversations')
    ])
  },
  mounted() {
    document.addEventListener('click', this.handleGlobalClick)
    this.$nextTick(() => {
      if (this.$refs.sessionList) {
        this.vsContainerH = this.$refs.sessionList.clientHeight || 600
      }
      // teleport 停用确认弹窗到 body，避免被祖先 transform/filter 困住
      const overlay = this.$refs.fireOverlay
      if (overlay && overlay.parentNode !== document.body) {
        document.body.appendChild(overlay)
      }
      // 同样把话题右键菜单 + 关闭任务确认弹窗 teleport 到 body
      const ctxMenu = this.$refs.topicCtxMenu
      if (ctxMenu && ctxMenu.parentNode !== document.body) {
        document.body.appendChild(ctxMenu)
      }
      const closeMask = this.$refs.topicCloseMask
      if (closeMask && closeMask.parentNode !== document.body) {
        document.body.appendChild(closeMask)
      }
      const renameMask = this.$refs.topicRenameMask
      if (renameMask && renameMask.parentNode !== document.body) {
        document.body.appendChild(renameMask)
      }
      const sessCtx = this.$refs.sessionCtxMenu
      if (sessCtx && sessCtx.parentNode !== document.body) {
        document.body.appendChild(sessCtx)
      }
    })
    // 每分钟刷新相对时间
    this._timeTimer = setInterval(() => { this._timeTick++ }, 60000)
  },
  beforeDestroy() {
    if (this._timeTimer) clearInterval(this._timeTimer)
    document.removeEventListener('click', this.handleGlobalClick)
    // 清理 teleport 到 body 的弹窗
    const ctxMenu = this.$refs.topicCtxMenu
    if (ctxMenu && ctxMenu.parentNode === document.body) {
      document.body.removeChild(ctxMenu)
    }
    const closeMask = this.$refs.topicCloseMask
    if (closeMask && closeMask.parentNode === document.body) {
      document.body.removeChild(closeMask)
    }
    const renameMask = this.$refs.topicRenameMask
    if (renameMask && renameMask.parentNode === document.body) {
      document.body.removeChild(renameMask)
    }
    const sessCtx = this.$refs.sessionCtxMenu
    if (sessCtx && sessCtx.parentNode === document.body) {
      document.body.removeChild(sessCtx)
    }
    const overlay = this.$refs.fireOverlay
    if (overlay && overlay.parentNode === document.body) {
      document.body.removeChild(overlay)
    }
  }
}
</script>
